/**
 * Reusable Avatar component — renders first letter with gradient background
 *
 * Usage:
 *   <Avatar name="John Doe" />
 *   <Avatar name="Jane" size="lg" />
 */
const SIZES = {
  xs: 'w-6 h-6 text-[10px]',
  sm: 'w-8 h-8 text-sm',
  md: 'w-10 h-10 text-base',
  lg: 'w-12 h-12 text-lg',
  xl: 'w-16 h-16 text-xl',
};

export default function Avatar({ name, size = 'sm', className = '', src }) {
  const sizeClass = SIZES[size] || (size.includes('w-') ? size : SIZES.sm);

  if (src) {
    return (
      <img
        src={src}
        alt={name || 'Avatar'}
        className={`${sizeClass} rounded-full object-cover flex-shrink-0 ${className}`}
      />
    );
  }

  return (
    <div
      className={`${sizeClass} bg-gradient-to-br from-brand-blue to-blue-400 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0 ${className}`}
    >
      {name?.charAt(0)?.toUpperCase() || '?'}
    </div>
  );
}




